<template>
  <section class="hero has-background-primary pb-6">
    <div class="hero-body">
      <div class="container">
        <h1
          class="has-text-centered has-text-white pt-6"
          :class="width < 768 ? 'is-size-3' : 'is-size-1'"
          style="font-family: Calibri; font-weight: bold"
        >
          ¿POR QUÉ HACEMOS LA DIFERENCIA?
        </h1>
        <div class="block pt-6">
          <div class="columns is-variable" :class="width < 768 ? '' : 'is-8'">
            <div class="column">
              <div>
                <p
                  class="has-text-primary has-text-centered is-size-5"
                  style="font-family: Calibri; font-weight: bold"
                >
                  <svg-icon
                    type="mdi"
                    :path="mdiCheckboxMarkedCircle"
                    style="
                      color: #38ac61;
                      vertical-align: text-bottom;
                      width: 110px;
                      height: 110px;
                      border-radius: 50%;
                    "
                  ></svg-icon>
                </p>
              </div>
              <div>
                <p
                  class="has-text-white has-text-centered is-size-5 pt-4"
                  style="font-family: Calibri; font-weight: bold"
                >
                  REDUCIMOS LOS COSTOS EFECTIVAMENTE
                </p>
              </div>
              <div>
                <p
                  class="has-text-white has-text-justified is-size-6 pt-4"
                  style="font-family: Calibri; font-weight: bold"
                >
                  Por experiencia sabemos que los costos de mantenimiento, los
                  gastos en insumos y las mermas del producto son costos que
                  impactan fuerte la rentabilidad de la empresa; sí o sí la
                  tecnología que integramos a la línea genera una diferencia en
                  costos entre el antes vs después.
                </p>
              </div>
            </div>
            <div class="column">
              <div>
                <p
                  class="has-text-primary has-text-centered is-size-5"
                  style="font-family: Calibri; font-weight: bold"
                >
                  <svg-icon
                    type="mdi"
                    :path="mdiCheckboxMarkedCircle"
                    style="
                      color: #38ac61;
                      vertical-align: text-bottom;
                      width: 110px;
                      height: 110px;
                      border-radius: 50%;
                    "
                  ></svg-icon>
                </p>
              </div>
              <div>
                <p
                  class="has-text-white has-text-centered is-size-5 pt-4"
                  style="font-family: Calibri; font-weight: bold"
                >
                  ACORTAMOS TIEMPOS DE PRODUCCIÓN
                </p>
              </div>
              <div>
                <p
                  class="has-text-white has-text-justified is-size-6 pt-4"
                  style="font-family: Calibri; font-weight: bold"
                >
                  Somos buenos detectando los cuellos de botella y aún más para
                  dar solución con tecnología. Entre nuestros logros están:
                  aumentar la capacidad de producción, sin sacrificar la
                  seguridad del operador y la calidad del producto, y
                  automatizar líneas completas de producción en pharma y
                  alimentos.
                </p>
              </div>
            </div>
            <div class="column">
              <div>
                <p
                  class="has-text-primary has-text-centered is-size-5"
                  style="font-family: Calibri; font-weight: bold"
                >
                  <svg-icon
                    type="mdi"
                    :path="mdiCheckboxMarkedCircle"
                    style="
                      color: #38ac61;
                      vertical-align: text-bottom;
                      width: 110px;
                      height: 110px;
                      border-radius: 50%;
                    "
                  ></svg-icon>
                </p>
              </div>
              <div>
                <p
                  class="has-text-white has-text-centered is-size-5 pt-4"
                  style="font-family: Calibri; font-weight: bold"
                >
                  AUMENTAMOS LA SEGURIDAD
                </p>
              </div>
              <div>
                <p
                  class="has-text-white has-text-justified is-size-6 pt-4"
                  style="font-family: Calibri; font-weight: bold"
                >
                  Nos tomamos muy en serio la seguridad del producto y del
                  operador. Nuestros equipos cuentan con normas y
                  certificaciones internacionales que los catalogan como
                  tecnología segura y confiable, además en todo momento contamos
                  con el servicio de asesoría para entrenar a los técnicos y
                  obtener el máximo provecho de los equipos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import SvgIcon from "@jamescoyle/vue-icon";
import { useWindowSize } from "vue-window-size";
import { mdiCheckboxMarkedCircle } from "@mdi/js";

const { width } = useWindowSize();
</script>
